import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

@Component({
  selector: 'ui-text-label',
  templateUrl: './text-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './text-label.component.scss',
})
export class TextLabelComponent {
  public readonly text: InputSignal<string> = input.required<string>();
}
